import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  infoIcon: {
    id: `app.components.InfoTooltip.infoIcon`,
    defaultMessage: 'info icon',
  },
});
